import { cn } from '@/lib/utils';

interface UserAvatarProps {
  name: string;
  colorHex?: string | null;
  url?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-12 w-12 text-sm',
  xl: 'h-20 w-20 text-2xl',
};

export function UserAvatar({ name, colorHex, url, size = 'md', className }: UserAvatarProps) {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
  const bg = colorHex ?? '#111111';

  if (url) {
    return (
      <img
        src={url}
        alt={name}
        className={cn('rounded-full object-cover', sizeMap[size], className)}
      />
    );
  }
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full font-semibold text-white',
        sizeMap[size],
        className,
      )}
      style={{ backgroundColor: bg }}
      aria-label={name}
    >
      {initials || '?'}
    </div>
  );
}
